<script setup lang="ts">

import IOHeroContentMenuBuffer from "@/components/io/io-hero/content/IOHeroContentMenuBuffer.vue";

const { $viewport } = useNuxtApp()
const w = computed(() => $viewport?.w ? $viewport.w.value : 0)

const debug = ref(false)

const props = withDefaults(defineProps<{
  id: string,
  w?: string,
  content?: {
    tags?: Array<{
      label: string,
      type?: string
    }>,
    hairline?: string,
    hairlineColour?: string,
    title?: string,
    primaryColour?: string,
    description?: string,
    descriptionColour?: string
  },
}>(), {
  id: 'index',
  w: 'w-full max-w-85% mx-auto txs:max-w-85% mx-auto grid grid-cols-[1fr] ds:grid-cols-[1fr] g-1 gpb-4 gpt-3 ',
  content: () => ({
    hairline: 'STEP INTO',
    hairlineColour: 'white',
    title: 'your authentic power',
    primaryColour: 'white',
    description: 'Explore a journey of deep healing, self-discovery, and personal transformation. Through immersive therapy, conscious coaching, and tailored healing experiences, unlock the path to a more authentic, empowered you.',
    descriptionColour: 'white',
  }),
})

const hairlineColour = computed(() => props.content?.hairlineColour || 'white')
const primaryColour = computed(() => props.content?.primaryColour || 'white')
const descriptionColour = computed(() => props.content?.descriptionColour || 'white')



// Text itself
// const containerHeight = 100;
// const lineHeight = 1.2

</script>

<template>
  <div class="io-hero-content default w-full flex-1 flex flex-col items-center justify-center h-full" :class="id">

    <IOHeroContentMenuBuffer :id="id" :height="'120px'" />

    <div class="content-container flex-1 w-full flex flex-col justify-end" :class="w">
      
      <div class="col-content w-full max-w-85% mx-auto gmb-2">

        <div class="hero-content-container grid g-2 mlx:m-auto ds:g-1 max-w-92% txs:max-w-85% ds:max-w-66% lt-ds:mx-auto" :class="{ 'debug': debug }">

          <div class="sec-titles relative grid g-1">
            
            <div v-if="content.tags && content.tags.length > 0" class="sec-tags flex gap-2 mb-2">
              <div 
                v-for="(tag, index) in content.tags" 
                :key="`tag-${index}`"
                class="sec-tag"
                :class="`tag-type-${tag.type || 'default'}`"
              >
                {{ tag.label }}
              </div>
            </div>
            
            <div class="sec-hairline top-0 ds:gmb-0" v-if="content.hairline" v-html="content.hairline" :style="{ color: hairlineColour }" />
            <!-- {{ content.hairline }} -->
            <!-- </div> -->

            <div class="sec-title font-secondary" v-if="content.title" v-html="content.title" :style="{ color: primaryColour }" />

          </div>

          <div class="sec-description" v-if="content.description" v-html="content.description" :style="{ color: descriptionColour }" />

        </div>
      </div>

  </div>
  </div>
</template>

<style lang="scss" scoped>
.io-hero-content {

  display: flex;
  align-items: center;
  justify-content: flex-end;

  .io-content-menu-buffer {}

  .content-container {
    width: 100%;

    .col-content {

      .hero-content-container {
        container-type: inline-size;
        container-name: hero-content;

        &.debug {
          border: 1px solid red;

          :deep(.mural-wrap) {
            border: 1px solid blue;
            .mural {
              border: 1px solid green;
            }
          }

        }
    
      }

      .sec-titles {
        width: 100%;
        height: 100%;

        .sec-tags {
          .sec-tag {
            padding: 0.25rem 0.75rem;
            font-size: fs(-1);
            text-transform: uppercase;
            letter-spacing: 0.1em;
            font-weight: 500;
            border-radius: 4px;
            background-color: rgba(255, 255, 255, 0.15);
            color: white;
            backdrop-filter: blur(10px);
            border: 1px solid rgba(255, 255, 255, 0.2);
            white-space: nowrap;

            // Different tag types can have different styles
            &.tag-type-category {
              background-color: rgba(0, 123, 255, 0.2);
              border-color: rgba(0, 123, 255, 0.3);
            }

            &.tag-type-subcategory {
              background-color: rgba(40, 167, 69, 0.2);
              border-color: rgba(40, 167, 69, 0.3);
            }

            @include mq($until: txs) {
              font-size: fs(-1.5);
              padding: 0.2rem 0.6rem;
            }
          }
        }

        .sec-hairline {
          font-size: fs(-1);
          letter-spacing: 0.4em;
          text-transform: uppercase;
          font-weight: 400;

          @include mq($until: txs) {
            font-size: fs(0.5);
          }
        }

        .sec-title {
          font-size: fs(6);
          font-weight: 400;
          line-height: 1.1;
          text-transform: capitalize;

          @include mq($until: txs) {
            font-size: fs(5);
            line-height: gr(2.25);
            max-width: 96%;
          }
        }

        .mural-title {
        }

        
        // @container (max-width: 767px) {
        //   .mural-title {
        //     :deep(.mural) {
        //       font-size: clamp(100px, 9vw, 120px); 
        //     }
        //   }
        // }
      }

      .sec-description {
        font-size: fs(1);
        color: white;
        font-weight: 400;
        line-height: gr(1.4);
        @include mq($until: mlx) {
          max-width: 85%;
          margin-right: auto;
        }

        * {
          font-size: fs(1);
          font-weight: 400;
          line-height: gr(1.2);
        }
      }

    }
  }




}
</style>